import Nullstack from 'nullstack';
export default function IconBuildingSkyscraper({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-skyscraper",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "21",
    x2: "21",
    y2: "21"
  }), "   ", Nullstack.element("path", {
    d: "M5 21v-14l8 -4v18"
  }), "   ", Nullstack.element("path", {
    d: "M19 21v-10l-6 -4"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "9",
    x2: "9",
    y2: "9.01"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "12",
    x2: "9",
    y2: "12.01"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "15",
    x2: "9",
    y2: "15.01"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "18",
    x2: "9",
    y2: "18.01"
  }), " ");
}